<template>
  <li :class="liClass">
    <a :class="'nav-link '+className" :id="id" :href="url" :role="role" :aria-controls="ariaControls" :aria-selected="ariaSelected || null" @click="callClicked">
      <slot name="title" v-if="hasTitleSlot" />
      <template v-else>
        {{ title }}
      </template>
    </a>
  </li>
</template>
<script>
  import { hasSlotContent } from '../../../utils/slotContent'

  export default {
    name: 'tab-nav-items',
    emits: ['click'],
    props: {
      id: { type: String, default: 'myTab' },
      active: { type: Boolean, default: false },
      role: { type: String, default: 'tab' },
      ariaControls: { type: String, default: 'tabpanel' },
      ariaSelected: { type: Boolean, default: false },
      href: { type: String, default: '' },
      title: { type: String, default: '' },
      liClass: { type: String, default: 'nav-item' }
    },
    mounted() {
      if (this.active) {
        this.className = 'show active'
      }
    },
    methods: {
      callClicked() {
        this.$emit('click')
      }
    },
    computed: {
      hasTitleSlot() {
        return hasSlotContent(this.$slots.title)
      },
      url() {
        if (this.href === '') {
          return '#' + this.ariaControls
        }
        return this.href
      }
    },
    data() {
      return {
        className: ''
      }
    }
  }
</script>
